import(/* webpackMode: "eager" */ "/vercel/path0/src/app/rewards/page.tsx");
